import ChangePasswordForTutor from './ChangePasswordForTutor';

export default ChangePasswordForTutor;
